import { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Input,
  Flex,
  Textarea,
  Text,
  HStack,
  Checkbox,
  FormControl,
  FormErrorMessage,
  Grid,
  useTheme,
} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { useToastContext } from "../../toastNotificationProvider/ToastNotificationProvider";
import TimePicker from "react-time-picker-input";
import openFileDialog from "../../../utils/openFileDialog";
import { FiX } from "react-icons/fi";
import SubmitButton from "../../buttons/SubmitButton";
import "./timepickerdefaultstyles.css";
import {
  createLiveclass,
  getAllStaticLiveClasses,
} from "../../../store/slice/classScheduleSlice";
import { getLectureNo } from "../../../store/slice/lectureSlice";
import { extractFileName } from "../../../utils/extractFileNameFromUrl";
import { useDispatch, useSelector } from "react-redux";
const ClassScheduleModal = ({ isOpen, onClose, editData }) => {
  const [formData, setFormData] = useState({
    subjectId: null,
    chapter: null,
    topic: null,
    scheduledDate: "",
    scheduledStartTime: "--:--",
    scheduledEndTime: "--:--",
    classLevelId: null, // ye 11,12
    classTypeId: null,
    lecture: "",
    agenda: "",
    description: "",
    yearId: null,
    muteAllStudents: false,
    blockStudentsCamera: true,
    isSoloClass: false,
  });

  const dispatch = useDispatch();
  const { addNotification } = useToastContext();
  const theme = useTheme();
  const { subjects, chapters, topics, classLevels, classTypes, years } =
    useSelector((state) => state.classes.staticData);
  const lectureNo = useSelector((state) => state.lecture.lecture);
  const lectureStatus = useSelector((state) => state.lecture.status);

  const { primaryBlue, primaryBlueLight } = theme.colors.pallete;

  const [scheduleClassFormErrorData, setScheduleClassFormErrorData] = useState(
    {}
  );

  const [selectedFiles, setSelectedFiles] = useState([]); // for file upload
  const [previousFile, setPreviousFiles] = useState([]); // for file upload
  const [deletedFileIds, setDeletedFileIds] = useState([]); // for file upload

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;

    setFormData((prev) => {
      const newFormData = {
        ...prev,
        [name]: selectedOption ? selectedOption.value : null,
      };

      // Reset chapter if subject is changed
      if (name === "subjectId") {
        newFormData.chapter = null;
        newFormData.topic = null;
      }

      return newFormData;
    });

    // Clear error if value is present
    if (selectedOption) {
      setScheduleClassFormErrorData((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (value) {
      setScheduleClassFormErrorData((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
  const handleDateChange = (value, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (value) {
      setScheduleClassFormErrorData((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  useEffect(() => {
    if (isOpen) {
      dispatch(getAllStaticLiveClasses());
    }
  }, [dispatch, isOpen]);

  const validateForm = () => {
    let newErrors = {};

    if (!formData.subjectId) newErrors.subjectId = "Subject is required.";
    if (!formData.chapter) newErrors.chapter = "Chapter is required.";
    if (!formData.topic) newErrors.topic = "Topic is required.";
    if (!formData.scheduledDate) newErrors.scheduledDate = "Date is required.";
    if (!formData.scheduledStartTime)
      newErrors.scheduledStartTime = "Start time is required.";
    if (!formData.scheduledEndTime)
      newErrors.scheduledEndTime = "End time is required.";
    if (!formData.classLevelId)
      newErrors.classLevelId = "Class Level is required.";

    if (!formData.classTypeId)
      newErrors.classTypeId = "Class Type is required.";

    if (!formData.yearId) newErrors.yearId = "Year is required.";

    // if (!formData.files) newErrors.files = "Files are required";
    if (!formData.agenda) newErrors.agenda = "Agenda is required.";
    if (!formData.description)
      newErrors.description = "Description is required.";
    setScheduleClassFormErrorData(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    let formDatas = new FormData();
    formDatas.append("subjectId", formData.subjectId);
    formDatas.append("chapterId", formData.chapter);
    formDatas.append("topicId", formData.topic);
    formDatas.append("classTypeId", formData.classTypeId);
    formDatas.append("classLevelId", formData.classLevelId);
    formDatas.append("yearId", formData.yearId);
    formDatas.append("scheduledDate", formData.scheduledDate);
    formDatas.append("scheduledStartTime", formData.scheduledStartTime);
    formDatas.append("scheduledEndTime", formData.scheduledEndTime);
    formDatas.append("agenda", formData.agenda);
    formDatas.append("description", formData.description);
    formDatas.append("lectureNo", formData.lecture);
    formDatas.append("muteAllStudents", false);
    formDatas.append("blockStudentsCamera", false);

    selectedFiles.forEach((file, index) => {
      formDatas.append("files", file); // or use `files[]` if backend expects array
    });

    setIsSubmitLoading(true);

    handleCreateLiveClass(formDatas);
  };

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        subjectId: "",
        chapterId: "",
        topicId: "",
        classTypeId: "",
        classLevelId: "",
        yearId: "",
        scheduledDate: "",
        scheduledStartTime: "--:--",
        scheduledEndTime: "--:--",
        agenda: "",
        description: "",
        lecture: "",
        muteAllStudents: false,
        blockStudentsCamera: false,
      });
      setScheduleClassFormErrorData({});
    }
  }, [isOpen]);

  const handleCreateLiveClass = (formDatas) => {
    dispatch(createLiveclass(formDatas))
      .unwrap()
      .then((response) => {
        console.log("Class has been created successfully:", response);
        addNotification("Class has been created successfully", "success", 3000);
        onClose();
      })
      .catch((error) => {
        console.error("Error creating class:", error);
        addNotification("Error creating class", "error", 4000);
      })
      .finally(() => {
        setIsSubmitLoading(false);
      });
  };

  const handleFileUpload = async () => {
    const files = await openFileDialog();
    const mergedArray = [...selectedFiles, ...files];
    const result = mergedArray.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.name === item.name)
    );
    setSelectedFiles(result);
  };

  const fetchLectureNo = (subjectId, classTypeId, classLevelId, yearId) => {
    dispatch(getLectureNo({ subjectId, classTypeId, classLevelId, yearId }));
  };

  useEffect(() => {
    const { subjectId, classTypeId, classLevelId, yearId } = formData;
    if (isOpen && yearId && classTypeId && classLevelId && subjectId) {
      fetchLectureNo(subjectId, classTypeId, classLevelId, yearId);
    }
  }, [
    formData.year,
    formData.classTypeId,
    formData.classLevelId,
    formData.subjectId,
    isOpen,
  ]);

  useEffect(() => {
    if (lectureStatus === "succeeded" && lectureNo !== undefined) {
      setFormData((prev) => ({
        ...prev,
        lecture: lectureNo + 1,
      }));

      setScheduleClassFormErrorData((prev) => ({
        ...prev,
        lecture: "",
      }));
    }
  }, [lectureNo, lectureStatus]);

  const removeFilefromPreviousList = (keyToRemove) => {
    // Convert FileList to array
    let fileArray = previousFile;
    let removeFileId = deletedFileIds;
    removeFileId.push(keyToRemove);
    let fileList = fileArray.filter((item) => item.id !== keyToRemove);
    setPreviousFiles(fileList);
    setDeletedFileIds(removeFileId);
  }; // test

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight={500} fontSize="1.2rem">
          {editData ? `Update Class` : `Schedule Class`}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isInvalid={!!scheduleClassFormErrorData.subjectId}>
            <Select
              placeholder="Select Subject"
              name="subjectId"
              value={
                formData.subjectId
                  ? {
                      value: formData.subjectId,
                      label:
                        subjects.find((s) => s.id === +formData.subjectId)
                          ?.name || "Select Subject",
                    }
                  : null
              }
              onChange={handleSelectChange}
              options={subjects.map((subject) => ({
                value: subject.id.toString(),
                label: subject.name,
              }))}
              useBasicStyles
            />
            <FormErrorMessage>
              {scheduleClassFormErrorData.subjectId}
            </FormErrorMessage>
          </FormControl>

          <Grid
            mt={3}
            templateColumns="repeat(2, 1fr)"
            gap={2}
            justifyContent="space-between"
            alignItems="start"
          >
            {/* Scheduled Date Input */}
            <FormControl
              isInvalid={!!scheduleClassFormErrorData?.scheduledDate}
            >
              <Input
                type="date"
                py={6}
                value={formData?.scheduledDate || ""}
                onChange={(e) =>
                  handleDateChange(e.target.value, "scheduledDate")
                }
              />
              {scheduleClassFormErrorData?.scheduledDate && (
                <FormErrorMessage>Please select a date</FormErrorMessage>
              )}
            </FormControl>

            <Box>
              <Flex alignItems="center" gap={1}>
                {/* Start Time Picker */}
                <Box position="relative">
                  <TimePicker
                    onChange={(value) =>
                      handleDateChange(value, "scheduledStartTime")
                    }
                    value={formData?.scheduledStartTime || ""}
                    eachInputDropdown
                    manuallyDisplayDropdown
                    hour12Format
                    minTime={new Date(Date.now() + 10 * 60 * 1000)} // current time + 10 min
                  />
                </Box>

                <Text>to</Text>

                {/* End Time Picker */}
                <Box>
                  <TimePicker
                    onChange={(value) =>
                      handleDateChange(value, "scheduledEndTime")
                    }
                    value={formData?.scheduledEndTime || ""}
                    eachInputDropdown
                    manuallyDisplayDropdown
                    hour12Format
                  />
                </Box>
              </Flex>

              {/* Error Messages */}
              {(scheduleClassFormErrorData?.scheduledStartTime ||
                scheduleClassFormErrorData?.scheduledEndTime) && (
                <Text fontSize="14px" fontWeight={400} mt={1} color="#E53E3E">
                  {scheduleClassFormErrorData?.scheduledStartTime ||
                    scheduleClassFormErrorData?.scheduledEndTime}
                </Text>
              )}
            </Box>
          </Grid>

          <Box my={3}>
            <FormControl isInvalid={!!scheduleClassFormErrorData.yearId}>
              <Select
                placeholder="Select JEE Year"
                name="yearId"
                value={
                  formData.yearId
                    ? {
                        value: formData.yearId,
                        label: years.find(
                          (y) => y.id.toString() === formData.yearId
                        )?.name,
                      }
                    : null
                }
                onChange={handleSelectChange}
                options={years.map((year) => ({
                  value: year.id.toString(),
                  label: year.name,
                }))}
                useBasicStyles
              />
              <FormErrorMessage>
                {scheduleClassFormErrorData.yearId}
              </FormErrorMessage>
            </FormControl>
          </Box>

          <FormControl
            isInvalid={!!scheduleClassFormErrorData.classLevelId}
            mt={4}
          >
            <Select
              placeholder="Select Class Level..."
              name="classLevelId"
              onChange={handleSelectChange}
              value={
                formData.classLevelId
                  ? {
                      value: formData.classLevelId,
                      label:
                        classLevels.find(
                          (s) => s.id.toString() === formData.classLevelId
                        )?.name || "Select Class Level",
                    }
                  : null
              }
              options={classLevels.map((classLevel) => ({
                value: classLevel.id.toString(),
                label: classLevel.name,
              }))}
            />
            {scheduleClassFormErrorData.classLevel && (
              <FormErrorMessage>
                {scheduleClassFormErrorData.classLevel}
              </FormErrorMessage>
            )}
          </FormControl>

          <Box my={3}>
            <FormControl
              isInvalid={!!scheduleClassFormErrorData.chapter}
              isDisabled={!!formData.subjectId}
            >
              <Select
                placeholder="Select Chapter"
                name="chapter"
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    chapter: Number(selectedOption.value),
                  }))
                }
                isDisabled={!formData.subjectId}
                value={
                  formData.chapter
                    ? {
                        value: formData.chapter.toString(),
                        label: chapters.find((s) => s.id === formData.chapter)
                          .name,
                      }
                    : null
                }
                options={chapters
                  .filter(
                    (chapter) =>
                      chapter.subjectId === Number(formData.subjectId)
                  )
                  .map((chapter) => ({
                    value: chapter.id.toString(),
                    label: chapter.name,
                  }))}
              />
              {scheduleClassFormErrorData.chapter && (
                <FormErrorMessage>
                  {scheduleClassFormErrorData.chapter}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>

          <Box my={3}>
            <FormControl
              isDisabled={!formData.chapter}
              isInvalid={!!scheduleClassFormErrorData.topic}
            >
              <Select
                placeholder="Select Topic"
                name="topic"
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    topic: Number(selectedOption.value),
                  }))
                }
                isDisabled={!formData.chapter}
                value={
                  formData.topic
                    ? {
                        value: formData.topic.toString(),
                        label: topics.find((s) => s.id === formData.topic).name,
                      }
                    : null
                }
                options={topics
                  .filter(
                    (topic) => topic.chapterId === Number(formData.chapter)
                  )
                  .map((topic) => ({
                    value: topic.id.toString(),
                    label: topic.name,
                  }))}
              />
              {scheduleClassFormErrorData.topic && (
                <FormErrorMessage>
                  {scheduleClassFormErrorData.topic}
                </FormErrorMessage>
              )}
            </FormControl>
            {scheduleClassFormErrorData.topic && (
              <FormErrorMessage>
                {scheduleClassFormErrorData.topic}
              </FormErrorMessage>
            )}
          </Box>
          <Box my={3}>
            <FormControl isInvalid={!!scheduleClassFormErrorData.classTypeId}>
              <Select
                placeholder={"Select Course Type"}
                onChange={handleSelectChange}
                name="classTypeId"
                value={
                  formData.classTypeId
                    ? {
                        value: formData.classTypeId,
                        label: classTypes.find(
                          (s) => s.id.toString() === formData.classTypeId
                        ).name,
                      }
                    : null
                }
                options={classTypes.map((classType) => ({
                  value: classType.id.toString(),
                  label: classType.name,
                }))}
                useBasicStyles
              />

              {scheduleClassFormErrorData["classTypeId"] && (
                <FormErrorMessage>
                  {scheduleClassFormErrorData["classTypeId"]}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>

          <FormControl isInvalid={!!scheduleClassFormErrorData.lecture}>
            <Input
              name="lecture"
              disabled={true}
              type="text"
              placeholder="Lecture"
              value={formData.lecture || ""}
            />
            {scheduleClassFormErrorData.lecture && (
              <FormErrorMessage>
                {scheduleClassFormErrorData.lecture}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl isInvalid={!!scheduleClassFormErrorData.agenda} mt={4}>
            <Textarea
              name="agenda"
              value={formData.agenda}
              onChange={handleInputChange}
              placeholder="Agenda"
            />
            {scheduleClassFormErrorData.agenda && (
              <FormErrorMessage>
                {scheduleClassFormErrorData.agenda}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl
            isInvalid={!!scheduleClassFormErrorData.description}
            mt={4}
          >
            <Textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Description"
            />
            {scheduleClassFormErrorData.description && (
              <FormErrorMessage>
                {scheduleClassFormErrorData.description}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl>
            <Flex my={3}>
              <Flex
                w={"80%"}
                border={"1px solid #E2E8F0"}
                marginRight={2}
                borderRadius={"md"}
                alignItems={"center"}
                pl={4}
                cursor={"pointer"}
                overflowX="auto"
                scrollBehavior="smooth"
              >
                <Text color="#718096">Files to Upload</Text>
              </Flex>{" "}
              <Button
                w={"20%"}
                bg={primaryBlue}
                _hover={{ bg: primaryBlueLight }}
                color="white"
                fontSize={"14px"}
                fontWeight={500}
                py={6}
                px={20}
                onClick={handleFileUpload}
              >
                Select Files
              </Button>
            </Flex>
          </FormControl>

          <Flex direction="column" gap={2}>
            {selectedFiles.map((file, index) => (
              <Flex
                key={index}
                justifyContent="space-between"
                alignItems="center"
                border="1px solid #E2E8F0"
                px={3}
                py={2}
                borderRadius="md"
              >
                <Text fontSize="sm" color="gray.600">
                  {file.name}
                </Text>
                <Button size="xs" colorScheme="red">
                  Remove
                </Button>
              </Flex>
            ))}
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Flex w={"full"} justifyContent={"center"}>
            <SubmitButton
              backColor={primaryBlue}
              textColor={"white"}
              onClickHandler={handleSubmit}
              isLoading={isSubmitLoading}
              hoverColor={primaryBlueLight}
              text={editData ? "Update Class" : "Schedule Class"}
            />
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ClassScheduleModal;
